import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect} from "react";
import Loader from '../../../utils/Loader';
import { yupResolver } from "@hookform/resolvers/yup";
import { useUploadFileMutation,useShowResourceQuery,useUpdateResourceMutation,useGetCourseListQuery} from "../../../Services/api";
export default function UpdateStudent(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        coursecode: Yup.string().required("course name fields is required"),
        resources_name: Yup.string().required("name fields is required"),
        resources_type: Yup.string().required("type fields is required"),
    });
      const {
        data: showResource,
        isLoading: isGetLoading,
      } =  useShowResourceQuery({  params:props['id']});

      const [updateResource,isLoading] = useUpdateResourceMutation();
      const getResource= showResource?.data[0];
      var  defaultValues={
        coursecode:getResource?.coursecode,
        resources_name:getResource?.resources_name,
        resources_type:getResource?.resources_type,
        resources_link:getResource?.resources_link,
    };
    
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
      } = methods;
       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[showResource]) 
      const [UploadFile] = useUploadFileMutation();
    const updateResourceList = (values,e) => {
        const formData = new FormData();
        formData.append('coursecode', values.coursecode);
        formData.append('resources_name', values.resources_name);
        formData.append('resources_type', values.resources_type);
        if(showLink==='1'){
            formData.append('file', values.resource_file[0]);
            formData.append('type','resource');
        }
        else{
            formData.append('resources_link', values.resources_link);
        }
        formData.append('id', props['id']);
        ///////////////
        UploadFile( formData)
        .unwrap()
        .then((payload) => {
        
        })
        .catch((error) => {
        
        });
        //////////////////
        updateResource(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    const [showLink, setShowLink] = React.useState('0')
    const resourcesType = (e) =>{
        setShowLink(e.target.value)  
    } 
    
    if(isGetLoading) return  <Loader></Loader>
    let link_types = "";
    if(showLink==='1'){
        link_types= <div className="row mb-3">
        <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources file</label>
        <div className="col-sm-10">
            <input type="file" {...register("resource_file")} className="form-control" />
        </div>
        </div>
    }
    else if(showLink==='2'){
        link_types= <div className="row mb-3">
        <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources link</label>
        <div className="col-sm-10">
            <input type="name" {...register("resources_link")} className="form-control" />
           
        </div>
        </div>
    }
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Resource</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Resource</h5>
                        <form onSubmit={handleSubmit(updateResourceList)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                            <div className="col-sm-10">
                               <select  {...register("coursecode")} className="form-control" >
                                 <option value="">Select Course</option>                                           

                                {                            
                                getCourseList?.data?.map((item) => {
                                    return (
                                        <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                <span className="text-danger">{errors.coursecode?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources Name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("resources_name")} className="form-control" />
                                <span className="text-danger">{errors.resources_name?.message}</span>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Resources Type</label>
                            <div className="col-sm-10">
                                <select  {...register("resources_type")} className="form-control" onChange={resourcesType}>
                                 <option value="">Select Type</option>  
                                 <option value="1">File</option>                                           
                                 <option value="2">Url Link</option>  
                                </select>
                                <span className="text-danger">{errors.resources_type?.message}</span>
                            </div>
                        </div>
                        { link_types }
                        
                        <div className="modal-footer">
                               
                                  {isLoading.status !='pending' ? 
                                                
                                    <>
                                        <button type="submit" className="btn btn-warning">Save changes</button>
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    </>
                                    :
                                    <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}